<!-- 一个iframe -->
<template>
  <div class="iframe-page">
    <iframe v-if="iframeUrl" :src="iframeUrl" frameborder="0"></iframe>
    <p v-else>加载中</p>
  </div>
</template>

<script>

export default {
  components: {
  },
  computed: {

    configData() {
      console.log('this._config_page', this._config_page);
      return (
        this._config_page || {
          url: '',
        }
      );
    },
  },
  data() {
    return {
      initializing: true,
      isTabbar: false,
      iframeUrl: ""
    }
  },
  created() {
    const customerId = this.$route.query.customerId;
    if (customerId && this.$route.query.writeUser) {
      localStorage.setItem('loginUserInfo', JSON.stringify({
        customerId: customerId,
      }));
      localStorage.setItem('customerId', customerId);
    }


    window.addEventListener('message', this.handleMessage)
  },
  mounted() {
    this.getIframeUrl();
    // this.isTabbar = this.hasTabbar();
    // setTimeout(() => {
    //   this.isTabbar = this.hasTabbar();
    //   console.log('this.isTabbar', this.isTabbar);
    // }, 1200);

    // initializing
    if (this.$route.query.type !== 'mealcoupon') {
      this.initializing = false;
      return;
    }
  },
  destroyed() {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    getIframeUrl() {
      let url = {
        'meal-h5': `${this._domainBaseUrl}/h5/meal-h5/#/`,
        'mealcoupon': `${this._domainBaseUrl}/cdh5/#/`,
        'mealcouponApply': `${this._domainBaseUrl}/cdh5/#/apply`,
        // 'mealcoupon': `${this._domainBaseUrl}/cdh6/#/`,
        // 'mealcouponApply': `${this._domainBaseUrl}/cdh6/#/apply`,
        'mall-h5': `${this._domainBaseUrl}/h5/mall-h5/#/`,
      }[this.$route.query.type];
      console.log(url,'urlurlurlurl');
      
      url = url || this.configData.url;
      if (!url) return null;
      let rolesStr = localStorage.getItem("loginUserInfo");
      let customerId = this.$route.query.customerId || sessionStorage.getItem('customerId') || localStorage.getItem('customerId');
      const shopId = localStorage.getItem('shopId');
      const branchId = sessionStorage.getItem('branchId') || localStorage.getItem('branchId') || '';
      const language = localStorage.getItem('language') || 'CN';
      let roles = JSON.parse(localStorage.getItem("customerInfoList"));
      const customerName = roles?.[0]?.username;
      const customerNameEn = roles?.[0]?.usernameEn;
      const userPhone = roles?.[0]?.phone;
      if (rolesStr) {
        try {
          customerId = JSON.parse(rolesStr).customerId;
        } catch (error) {
          console.log('error', error);
        }
      }
      const baseURL = `${url}?customerId=${customerId}&shopId=${shopId}&branchId=${branchId}&language=${language}&customerName=${customerName}&phone=${userPhone}&customerNameEn=${customerNameEn}`;
      if (this.$route.query.query) {
        return `${baseURL}&${this.$route.query.query}`;
      }
      console.log(baseURL, 'iframeUrliframeUrliframeUrl');
      this.iframeUrl = baseURL;
      return baseURL;
    },
    _domainBaseUrl() {
      const baseURL =
        location.origin +
        location.pathname
          .replace("h5", "")
          .replace("index.html", "")
          .replace(/\/+/g, "/")
          .replace(/\/$/, "");
      console.log(baseURL, 'baseURLbaseURLbaseURL');
      return baseURL;
    },
    handleMessage(e) {
      if (e.data === 'close_pc_dialog') {
        this.$router.back();
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.iframe-page {
  width: 100vw;
  background-color: #f5f6fe;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;


  p {
    font-size: 12px;
    color: #888;
    margin-top: 20px;
    text-align: center;
  }

  iframe {
    width: 100vw;
    height: 100vh;
  }

  &.hasTabbar {
    iframe {
      height: calc(100vh - 60px);
    }
  }
}
</style>